import { ClockinHistoryType } from '@business/entities/clockin';

export function getLogColor(type: ClockinHistoryType) {
  switch (type) {
    case ClockinHistoryType.created:
      return 'success';
    case ClockinHistoryType.updated:
      return 'info';
    case ClockinHistoryType.deleted:
      return 'danger';
    case ClockinHistoryType.stopped:
      return 'warning';
  }
}

export function convertSecondsToHourMinutes(seconds: number) {
  const addZero = (i: number) => (i < 10 ? `0${i}` : i);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${addZero(hours)}:${addZero(minutes)}`;
}
